import axios from 'axios'
import { server_url } from '../Settings'

axios.defaults.withCredentials = true

const fetchOptions = {
    withCredentials: true,
}

export async function getAdminUsers() {
    try {
        const resp = await axios.get(server_url + "/users/akldnm9201n2", fetchOptions)
        console.log("getAdminUsers response:", resp.data)
        return resp.data
    } catch (error) {
        console.error("getAdminUsers error:", error)
        throw error
    }
}

export async function getAdminToricResults() {
    try {
        const resp = await axios.get(server_url + "/results/akldnm9201n2", fetchOptions)
        return resp.data
    } catch (error) {
        console.error("getAdminToricResults error:", error)
        throw error
    }
}

export async function getAdminConstants() {
    try {
        const resp = await axios.get(server_url + "/constant/results/df1e8wd1we", fetchOptions)
        console.log("getAdminConstants response:", resp.data)
        return resp.data
    } catch (error) {
        console.error("getAdminConstants error:", error)
        throw error
    }
}